import React from 'react';
var HelpText = function (_a) {
    var className = _a.className, isRounded = _a.isRounded, children = _a.children;
    return children ? (React.createElement("div", { className: 'help-text ' + (isRounded ? ' rounded' : '') + (className ? ' ' + className : '') }, children)) : null;
};
export { HelpText };
//# sourceMappingURL=HelpText.js.map